/* this file is transformed by vux-loader */
/* eslint-disable */
import request from '@/utils/request';

// 头像上传
export function imagesUpdate() {
  var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/index/img/uploader';
  return request({
    url: url,
    method: 'post',
    data: param
  });
}

// 头像直接上传
export function imageUpload() {
  var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/images/upload';
  return request({
    url: url,
    method: 'post',
    data: param,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

// 视频上传
export function videoUpload() {
  var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/video/upload';
  return request({
    url: url,
    method: 'post',
    data: param,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

// base64上传图片
export function uploadByBase64() {
  var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/images/uploadByBase64';
  return request({
    url: url,
    method: 'post',
    data: param
  });
}

// 下载接口
export function fileDownload() {
  var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/index/img/fileDownload';
  return request({
    url: url,
    method: 'post',
    data: param
  });
}